import { useMutation, useQueryClient } from '@tanstack/react-query';
import { knowledgeService } from '../../../services/KnowledgeService';
import { knowledgeQueryKeys } from '../knowledgeQueryKeys';

export function useCreateKnowledgeDatabaseMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      name,
      description,
      icon,
    }: {
      name: string;
      description: string;
      icon?: string;
    }) => knowledgeService.createDatabase(name, description, icon),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: knowledgeQueryKeys.databases(),
      });
    },
  });
}

export function useUpdateKnowledgeDatabaseMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      database,
      updates,
    }: {
      database: Parameters<typeof knowledgeService.updateDatabase>[0];
      updates: Parameters<typeof knowledgeService.updateDatabase>[1];
    }) => knowledgeService.updateDatabase(database, updates),
    onSuccess: (_result, variables) => {
      void queryClient.invalidateQueries({
        queryKey: knowledgeQueryKeys.database(variables.database.id!),
      });
      void queryClient.invalidateQueries({
        queryKey: knowledgeQueryKeys.databases(),
      });
    },
  });
}

export function useDeleteKnowledgeDatabaseMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (databaseId: string) =>
      knowledgeService.deleteDatabase(databaseId),
    onSuccess: (_result, databaseId) => {
      void queryClient.invalidateQueries({
        queryKey: knowledgeQueryKeys.databases(),
      });
      queryClient.removeQueries({
        queryKey: knowledgeQueryKeys.database(databaseId),
      });
      queryClient.removeQueries({
        queryKey: knowledgeQueryKeys.documentsRoot(databaseId),
      });
      queryClient.removeQueries({
        queryKey: knowledgeQueryKeys.crawls(databaseId),
      });
      queryClient.removeQueries({
        queryKey: knowledgeQueryKeys.crawlSchedules(databaseId),
      });
      queryClient.removeQueries({
        queryKey: knowledgeQueryKeys.members(databaseId),
      });
    },
  });
}
